import { isUndefined } from 'lodash';

import type { NotificationPreferencesV2Type } from 'bundles/naptimejs/resources/notificationPreferences.v2';
import {
  CONSUMER_GRADIENTS,
  ENTERPRISE_GRADIENTS,
  UNSUBSCRIBED_PREFERENCE,
} from 'bundles/user-consent/constants/GdprConstants';

export const showBanner = (
  notificationPreferences?: NotificationPreferencesV2Type,
  isEnterprise = false,
  isAdmin = false
): boolean => {
  const shouldRenderConsumerBanner =
    !!notificationPreferences &&
    notificationPreferences.volunteer?.email === UNSUBSCRIBED_PREFERENCE &&
    notificationPreferences.promotions?.email === UNSUBSCRIBED_PREFERENCE &&
    notificationPreferences.recommendations?.email === UNSUBSCRIBED_PREFERENCE;
  const shouldRenderEnterpriseBanner =
    (!!notificationPreferences && isUndefined(notificationPreferences.enterpriseMarketing)) ||
    (!!notificationPreferences &&
      !!notificationPreferences.enterpriseMarketing &&
      notificationPreferences.enterpriseMarketing.email === UNSUBSCRIBED_PREFERENCE);

  /**
   * Scenarios when the GDPR Banner should be shown
   * 1. Enterprise + Admin gets notifications to keep their members on track
   * 2. Consumers get notifications to keep themselves on track
   *
   * Scenarios when the GDPR Banner should not be shown
   * 1. Enterprise consumers don't because we defer that to the administrators
   */
  if (isAdmin && isEnterprise) {
    return shouldRenderEnterpriseBanner;
  }
  if (!isAdmin && !isEnterprise) {
    return shouldRenderConsumerBanner;
  }
  return false;
};

export const getGradient = (isEnterprise = false, isAdmin = false) => {
  const gradientSrc = isEnterprise && isAdmin ? ENTERPRISE_GRADIENTS : CONSUMER_GRADIENTS;

  return gradientSrc[Math.floor(Math.random() * gradientSrc.length)];
};

type Gradient = {
  start: string;
  end: string;
  deg: number;
};

type GradientMap = {
  [key: string]: Gradient;
};

// This gradient group is temporarily copied from the coursera-ui codebase to remove the legacy import.
// TODO: We will replace it with a standardized color once color alignment is finalized.
export const gradient: GradientMap = {
  peach: {
    start: '#fc6e51',
    end: 'var(--cds-color-yellow-300)',
    deg: 90,
  },
  pear: {
    start: 'var(--cds-color-yellow-200)',
    end: '#8cc152',
    deg: 90,
  },
  kiwi: {
    start: '#a0d468',
    end: 'var(--cds-color-green-400)',
    deg: 90,
  },
  sea: {
    start: 'var(--cds-color-green-300)',
    end: '#3bafda',
    deg: 90,
  },
  coursera: {
    start: '#4fc1e9',
    end: '#4a89dc',
    deg: 90,
  },
  blueberry: {
    start: '#5d9cec',
    end: 'var(--cds-color-purple-400)',
    deg: 90,
  },
  grape: {
    start: 'var(--cds-color-purple-300)',
    end: 'var(--cds-color-pink-400)',
    deg: 90,
  },
  lightBlue: {
    start: '#E3EEFF',
    end: '#89B3EF',
    deg: 90,
  },
};
